import { render } from "./CustomerForm.vue?vue&type=template&id=c11d112c&ts=true"
import script from "./CustomerForm.vue?vue&type=script&lang=ts"
export * from "./CustomerForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__